export default function doesStartsWith(value, start) {
  return value.startsWith(start);
}
